import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmComponent } from '../confirm/confirm.component';
import { YesNoCancelComponent } from '../yes-no-cancel/yes-no-cancel.component';
import { NotificationComponent } from '../notification/notification.component';
import { MessageModalComponent } from '../message-modal/message-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  constructor(private modalService: NgbModal) {}

  confirm(
    title?: string,
    prompt?: string,
    okBtnText?: string,
    cancelBtnText?: string,
    okBtnIcon?: string,
    cancelBtnIcon?: string,
    okBtnClass?: string,
    cancelBtnClass?: string,
    reasonRequired?: boolean,
    reasonLabel?: string,
    reasonPlaceholder?: string
  ): Promise<any> {
    const modal = this.modalService.open(ConfirmComponent, { centered: true });
    if (title) {
      modal.componentInstance.title = title;
    }
    if (prompt) {
      modal.componentInstance.prompt = prompt;
    }
    if (cancelBtnClass) {
      modal.componentInstance.cancelBtnClass = cancelBtnClass;
    }
    if (okBtnClass) {
      modal.componentInstance.okBtnClass = okBtnClass;
    }
    if (cancelBtnText) {
      modal.componentInstance.cancelBtnText = cancelBtnText;
    }
    if (okBtnText) {
      modal.componentInstance.okBtnText = okBtnText;
    }
    if (reasonLabel) {
      modal.componentInstance.reasonLabel = reasonLabel;
    }
    if (reasonPlaceholder) {
      modal.componentInstance.reasonPlaceholder = reasonPlaceholder;
    }
    if (reasonRequired !== undefined) {
      modal.componentInstance.reasonRequired = reasonRequired;
    }
    modal.componentInstance.cancelBtnIcon = cancelBtnIcon || 'fa-times';
    modal.componentInstance.okBtnIcon = okBtnIcon || 'fa-check';

    return modal.result;
  }

  notify(
    prompt?: string,
    okBtnText?: string,
    okBtnIcon?: string,
    okBtnClass?: string
  ): Promise<any> {
    const modal = this.modalService.open(NotificationComponent, {
      centered: true,
    });
    if (prompt) {
      modal.componentInstance.prompt = prompt;
    }
    if (okBtnClass) {
      modal.componentInstance.okBtnClass = okBtnClass;
    }
    if (okBtnText) {
      modal.componentInstance.okBtnText = okBtnText;
    }
    modal.componentInstance.okBtnIcon = okBtnIcon || 'fa-check';

    return modal.result;
  }

  delete(
    title?: string,
    prompt?: string,
    okBtnText?: string,
    cancelBtnText?: string,
    okBtnIcon?: string,
    cancelBtnIcon?: string,
    okBtnClass?: string,
    cancelBtnClass?: string
  ): Promise<any> {
    return this.confirm(
      title,
      prompt,
      okBtnText || 'Delete',
      cancelBtnText,
      okBtnIcon || 'fa-trash-alt',
      cancelBtnIcon,
      okBtnClass || 'btn-danger',
      cancelBtnClass
    );
  }

  yesNoCancel(title?: string, prompt?: string): Promise<any> {
    const modal = this.modalService.open(YesNoCancelComponent);
    if (title) {
      modal.componentInstance.title = title;
    }
    if (prompt) {
      modal.componentInstance.prompt = prompt;
    }
    return modal.result;
  }

  message(title?: string, prompt?: string): Promise<any> {
    const modal = this.modalService.open(MessageModalComponent, {
      modalDialogClass: 'modal-dialog-centered',
    });
    if (title) {
      modal.componentInstance.title = title;
    }
    if (prompt) {
      modal.componentInstance.prompt = prompt;
    }
    return modal.result;
  }

  //Workaround for modal scroll lock issue.
  //Without this, scrolling may remain disabled after closing a modal.
  clearBodyScrollLocks(): void {
    const body = document.body;
    body.classList.remove('modal-open');
    body.style.removeProperty('overflow');
    body.style.removeProperty('padding-right');
    setTimeout(() => {
      body.classList.remove('modal-open');
      body.style.removeProperty('overflow');
      body.style.removeProperty('padding-right');
    }, 0);
    setTimeout(() => {
      body.classList.remove('modal-open');
      body.style.removeProperty('overflow');
      body.style.removeProperty('padding-right');
    }, 300);
    setTimeout(() => {
      body.classList.remove('modal-open');
      body.style.removeProperty('overflow');
      body.style.removeProperty('padding-right');
    }, 1000);
  }
}
